<div class="wrapper-billing" [class.embedded]="embedded">
  <div class="section-title" *ngIf="!embedded">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Order Subscription" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="checkout-toolbar mb-4" [class.is-collapsed]="!toolbarOpen">
    <div class="filter-options" id="subscriptionFilterOptions">
      <!-- Date Filter Dropdown -->
      <div ngbDropdown #dateDropdown="ngbDropdown" class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="dateFilter?.value !== 'cm' || (fromDate && toDate)"
          id="dropdownDateFilter"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-calendar mr-1"></i>
          <span>
            {{ (date.type?.display | translate) || (dateFilter?.display | translate) || ("Order Date" | translate) }}
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownDateFilter" class="custom-dropdown p-2" style="min-width: 260px;">
          <button ngbDropdownItem *ngFor="let filter of DATE_FILTERS" [disabled]="filter.selectable"
            (click)="dateUpdated(filter)">
            {{ "{0}" | translate : [utils.translate(filter.display)] }}
          </button>
          <div class="dropdown-divider"></div>
          <div class="px-2 date-range-picker">
            <p class="mb-2 font-weight-bold text-xs">{{ "Select a date range" | translate }}:</p>
            <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="1"
              [minDate]="this.minDate" [maxDate]="this.maxDate" [dayTemplate]="t" outsideDays="hidden">
            </ngb-datepicker>

            <ng-template #t let-date let-focused="focused">
              <div class="custom-day-container" [class.focused]="focused" [class.start-day]="date == fromDate"
                [class.end-day]="date == toDate" [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                <span class="custom-day">{{ date.day }}</span>
              </div>
            </ng-template>
            <div class="py-2 text-right">
              <button type="button" class="btn btn-date-range cancel mr-1" (click)="dateDropdown.close()">
                {{ "Cancel" | translate }}
              </button>
              <button type="button" class="btn btn-date-range" [disabled]="!fromDate || !toDate"
                (click)="dateDropdown.close(); setDueDate()">
                {{ "Apply" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Which date the range applies to -->
      <div ngbDropdown #moreFilters="ngbDropdown" class="d-inline-block" autoClose="outside" placement="bottom-left bottom-right">
        <button
          type="button"
          class="btn btn-filter btn-more-filters"
          [class.active]="moreFilterCount > 0"
          id="dropdownSubscriptionMoreFilters"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-settings-sliders mr-1"></i>
          <span>{{ "More filters" | translate }}</span>
          <span class="filter-count" *ngIf="moreFilterCount > 0">{{ moreFilterCount }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownSubscriptionMoreFilters" class="more-filters-menu">
          <section class="filter-group">
            <h5 class="filter-group-title" id="filterSubscriptionDateType">{{ "Date Type" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterSubscriptionDateType">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of subscriptionDateTypeFilters"
                [class.active]="isDateTypeSelected(filter)"
                [attr.aria-checked]="isDateTypeSelected(filter)"
                (click)="getSubscriptionDate(filter)"
              >
                {{ filter.value === "" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>
          <div class="more-filters-footer">
            <button type="button" class="btn filter-clear" [disabled]="moreFilterCount === 0" (click)="clearMoreFilters()">
              {{ "Clear" | translate }}
            </button>
            <button type="button" class="btn btn-primary filter-done" (click)="moreFilters.close()">
              {{ "Done" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Search; on phones the filters above fold behind the Filters button beside it -->
    <div class="toolbar-end">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="search"
          (change)="searchID($event)"
          (keyup.enter)="searchID($event)"
          placeholder="{{ 'Search Order ID, Receiver Name, Mobile' | translate }}"
        />
        <i class="fi fi-rr-search search-icon"></i>
        <i class="fas fa-times clear-icon" *ngIf="search" (click)="clearSubscriptionSearch()"></i>
      </div>
      <button
        type="button"
        class="btn toolbar-toggle"
        [class.active]="toolbarFilterCount > 0"
        [class.is-open]="toolbarOpen"
        [attr.aria-expanded]="toolbarOpen"
        aria-controls="subscriptionFilterOptions"
        (click)="toolbarOpen = !toolbarOpen"
      >
        <i class="fi fi-rr-filter" aria-hidden="true"></i>
        <span>{{ "Filters" | translate }}</span>
        <span class="filter-count" *ngIf="toolbarFilterCount > 0">{{ toolbarFilterCount }}</span>
        <i class="fi fi-rr-angle-small-down toggle-chevron" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="section-main">
    <div class="row" *ngIf="dataIsLoading; else loadedContent">
      <div class="loading-spinner col-12 mt-5">
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <ng-template #loadedContent>
      <div class="orders-panel subscriptions-panel">
        <!-- Status: one tab per status, each with its subscription count -->
        <div class="status-tabs" role="tablist" [attr.aria-label]="'Status' | translate" *ngIf="subscripiton?.length">
          <button
            type="button"
            role="tab"
            class="status-tab"
            *ngFor="let tab of statusTabs"
            [class.active]="isSelectedFilter(selectedSubscripitonStatus, tab.option)"
            [class.is-zero]="!tab.count"
            [attr.aria-selected]="isSelectedFilter(selectedSubscripitonStatus, tab.option)"
            (click)="selectStatusTab(tab.option)"
          >
            <span>
              {{
                tab.option.value === "ALL"
                  ? ("All" | translate)
                  : ("{0}" | translate : [utils.translate(tab.option.display || tab.option.value)])
              }}
            </span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <div class="orders-empty" *ngIf="!filteredSubsciptionHistoryList?.length">
          <img class="orders-empty-image" src="/assets/empty-cart.png" alt="" />
          <h3>{{ "No Order Subscription Found" | translate }}</h3>
          <p>
            {{ "We couldn't find any order subscription data for the selected filter." | translate }}
            <br />
            {{ "Try change the filter?" | translate }}
          </p>
        </div>

        <ng-container *ngIf="filteredSubsciptionHistoryList?.length">
          <div class="orders-head" aria-hidden="true">
            <span>{{ "Customer" | translate }}</span>
            <span>{{ "Products" | translate }}</span>
            <span>{{ "Status" | translate }}</span>
            <span>{{ "Cycle" | translate }}</span>
            <span class="text-right">{{ "Total" | translate }}</span>
            <span></span>
          </div>

          <div class="order-row" *ngFor="let data of filteredSubsciptionHistoryList" (click)="openFromRow(data)">
            <!-- Customer and when the subscription started -->
            <div class="order-cell sub-customer">
              <a
                class="sub-name"
                [routerLink]="getDetailLink(data.id)"
                (click)="$event.stopPropagation()"
                [title]="data.customerName"
              >
                {{ data.customerName || "-" }}
              </a>
              <span class="sub-meta" *ngIf="data.customerMobile">
                {{ data.customerMobilePrefix }}{{ data.customerMobile }}
              </span>
              <span class="sub-meta">{{ "Created" | translate }} {{ convertDate(data.createdAt) }}</span>
            </div>

            <!-- Products in the subscription -->
            <div class="order-cell sub-products">
              <span class="sub-product" *ngFor="let orderDetail of data.orderDetailInfo | slice: 0:2" [title]="orderDetail">
                {{ orderDetail }}
              </span>
              <span class="sub-meta" *ngIf="data.orderDetailInfo?.length > 2">
                {{ "+{0} more" | translate : [data.orderDetailInfo.length - 2] }}
              </span>
            </div>

            <div class="order-cell sub-status">
              <span class="status-chip" [ngClass]="getStatus(data.statusWord)?.class">
                {{ getStatus(data.statusWord)?.display | translate : [utils.translate(data.statusWord)] }}
              </span>
            </div>

            <!-- Where the subscription is in its cycle -->
            <div class="order-cell sub-cycle">
              <span
                class="sub-cycle-count"
                [title]="('Current Count' | translate) + ' / ' + ('Recurring Count' | translate)"
              >
                {{ data.currentCount }} / {{ data.recurringCount }}
              </span>
              <span class="sub-meta" *ngIf="convertRecurringDateDate(data.nextRecurringDate) !== '-'">
                {{ "Next" | translate }} {{ convertRecurringDateDate(data.nextRecurringDate) }}
              </span>
            </div>

            <div class="order-cell order-total sub-total">
              <span>{{ data.orderCurrency }} {{ data.orderPrice }}</span>
              <span class="sub-meta" *ngIf="data.orderPv">{{ data.orderPv }} PV</span>
            </div>

            <div class="order-cell order-actions" (click)="$event.stopPropagation()">
              <a
                class="row-open"
                [routerLink]="getDetailLink(data.id)"
                [attr.aria-label]="'Details' | translate"
                [title]="'Details' | translate"
              >
                <i class="fi fi-rr-angle-small-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row px-4 py-3 pagination" *ngIf="finalList?.length != 0">
        <div class="col-lg-3 flex">
          <ngb-pagination
            [collectionSize]="finalList.length"
            [(page)]="page"
            [pageSize]="selectedPage"
            aria-label="Default pagination"
            (pageChange)="changePage($event)"
            [maxSize]="5"
          ></ngb-pagination>
        </div>
        <div class="col-lg-3 lg-center paginationWrapper">
          <div class="mt-2 text-center">
            {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
            <b>{{ finalList.length }}</b>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </ng-template>
  </div>
</div>
